import React, { useRef, useState, useEffect } from "react"
import { useKeenSlider } from 'keen-slider/react';
//import KeenSlider from 'keen-slider'
import { format, subDays } from "date-fns"
import VisDiv from "./frontend_components/VisDiv";
import { FiSave } from 'react-icons/fi'
import {AiFillCloseCircle} from 'react-icons/ai';
import ShrinkText from "./ShrinkText";




const MonthYearWheel = ({wheelType = "monthYear", options=[], closeFn =()=>{}, dayMonth, time, initialData, saveFn=()=>{}}) => {

    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth()

    const [year, setYear] = useState(initialData?.year ? initialData?.year : currentYear)
    const [month, setMonth] = useState(initialData?.month ? initialData?.month : currentMonth + 1)
    const [selectedObj, setSelectedObj] = useState()

    const formatOptions = (_relative, absolute) => {
        return options[_relative]?.label
      }
       const formatDate = (_relative, absolute) => {
        const dateDayMonth = format(subDays(new Date(), absolute), "iii d LLL")
        const monthDate = format(new Date(), "LL yyyy")
        return dateDayMonth
      } 

      const saveObject = (data) => {
    
        //const doc = {year: data, month}
        //console.log("SAVE OBJECT", data)
        setSelectedObj(data)
        //saveFn(data)
        //save(doc)
        }
    
    const saveMonth = (data) => {
    
    //const doc = {year, month: data}

    setMonth(data)
    //save(doc)
    }
    const saveYear = (data) => {
    
    //const doc = {year: data, month}
    //console.log("SAVE YEAR", result)
    setYear(data)
    //save(doc)
    }
    
    const startYear = 1990

    const save = () =>{
        //console.log("TEST WHEEL", year, month)
        if(selectedObj) {
          saveFn(options[selectedObj-1])
        } else {
          saveFn({year, month})
        }
       
    }
    const testFunction = () =>{
        //console.log("TEST WHEEL", year, month)
    }

      return (

        <div>        
            <div style={{position:"relative",  left: 5, top: 5}}>
              <div style={{color:"white", display:"flex"}}>

                 <button
                      type="button"
                      className="sidebar-close-button"
                      style={{width: "43px", height: "43px", marginRight:"15px"
                      }}
                      onClick={()=> {closeFn(false)}}
                      >
                    <AiFillCloseCircle                       
                      size={55}
                      color={"white"}/>
                  </button>
                  <button type='button' style={{width: "40px", height: "40px", cursor:"pointer", borderRadius:"50%", backgroundColor:"green", border:"none"}} onClick={save}>
                      <FiSave            
                      size={20}
                      color={"white"}/>
                  </button>

              </div>
            </div>
  
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", padding:"10px"}}>
           
                  <VisDiv rules={[wheelType == "monthYear"]} style={{ width: 70, height: 180 }}>
                      <WheelPicker 
                          loop
                          startValue={1}
                          initIdx = {month - 1}
                          length={12} 
                          width={23} 
                          wheelValue={saveMonth}
                      />
                  </VisDiv>
                  <VisDiv rules={[wheelType == ("monthYear" || "year")]} style={{ width: 70, height: 180 }}>
                      <WheelPicker 
                          loop
                          initIdx = {(year) - startYear}
                          startValue={startYear}
                          //values={years}
                          length={(currentYear + 30) - startYear} 
                          width={23} 
                          wheelValue={saveYear}
                      />
                  </VisDiv>
 
                <VisDiv rules={[time]} style={{ width: 180, height: 180 }}>
                    <WheelPicker
                    loop={false}
                    length={24}
                    width={140}
                    perspective="right"
                    setValue={formatDate}
                    />
                </VisDiv>

                <VisDiv rules={[time]}>
                        <div style={{ width: 70, height: 180 }}>
                            <WheelPicker loop length={24} width={23} />
                        </div>
                        <div style={{ width: 70, height: 180 }}>
                            <WheelPicker loop length={60} width={23} perspective="left" />
                        </div>
                </VisDiv>
                <VisDiv rules={[wheelType == "dropdown"]} style={{ width: "80%", height: 180 }}>
                      <DropdownWheelPicker 
                          startValue={1}
                          initIdx = {month - 1}
                          length={options?.length} 
                          width={260} 
                          wheelValue={saveObject}
                          options = {options}
                          //setValue={formatOptions}
                      />
                  </VisDiv>
            </div>
        </div>
      )
}

export default MonthYearWheel


export const DropdownWheelPicker = (props) => {

  const perspective = props?.perspective || "center"
  const wheelSize = 20
  const slides = props?.length
  const slideDegree = 360 / wheelSize
  const slidesPerView = props?.loop ? 9 : 1
  const [sliderState, setSliderState] = useState(undefined)
  const size = useRef(0)

  function slideValues() {
      
      if (!sliderState) return []

      const offset = props?.loop ? 1 / 2 - 1 / slidesPerView / 2 : 0

      const formatOptions = (_relative, absolute) => {
        return props?.options[_relative]?.label
      }

      const values = !Array.isArray(props?.options) ? [] : props?.options?.map?.((item, i)=>{

        const distance = sliderState
          ? (sliderState?.slides[i]?.distance - offset) * (slidesPerView)*2
          : 0
       
        const rotate =
          Math.abs(distance) > wheelSize / 2
            ? 180
            : distance * (360 / wheelSize) * -1
        const style = {
          transform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
          WebkitTransform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
        }
        const value = () => {
            if(props?.options) return formatOptions(i, sliderState.abs + Math.round(distance))
            if(props?.startValue) return i + props?.startValue
           return i
        
        }
        const doc = { style, value: value() }
        return doc
        })

        return values
    }
  
  const optionsDoc = {
    slides: {
      number: slides,
      origin: props?.loop ? "center" : "auto",
      perView: slidesPerView,
    },

    vertical: true,

    initial: props?.initIdx || 0,
    loop: props?.loop,
    dragSpeed: (val) => {
      const height = size.current
      return (
        val *
        (height /
          ((height / 2) * Math.tan(slideDegree * (Math.PI / 80))) /
          slidesPerView)
      )
    },
    created: (s) => {
      size.current = s.size
      //console.log("CREATED:", s)
    },
    updated: (s) => {
      size.current = s.size
      console.log("UPDATED:", s)
    },
    optionsChanged: (s) => {
      //console.log("SLIDE CHANGED:", s)
      //props?.wheelValue && props?.wheelValue(props?.startValue ? s.track.details?.rel + props?.startValue : s.track.details?.rel) 
    },
    detailsChanged: (s) => {
      setSliderState(s.track.details) 
      props?.wheelValue && props?.wheelValue(props?.startValue ? s.track.details?.rel + props?.startValue : s.track.details?.rel) 
      //console.log("CHANGED:", s.track.details)
    },
    rubberband: !props?.loop,
    mode: "snap",
  }

  const [options, setOptions] = useState(optionsDoc)

  const [sliderRef, slider] = useKeenSlider(options)

  const [radius, setRadius] = React.useState(0)

  useEffect(() => {
    if (slider.current) setRadius(slider.current.size / 2)
      setOptions(optionsDoc)
      console.log("bjehbdjsb", slider, slides)
  }, [slider, slides])



  return (
    <div
      className={"wheel keen-slider wheel--perspective-" + perspective}
      ref={sliderRef}
    >
      <div
        className="wheel__shadow-top"
        style={{
          transform: `translateZ(${radius}px)`,
          WebkitTransform: `translateZ(${radius}px)`,
        }}
      />
      <div className="wheel__inner" style={{height: "18%"}}>
        <div className="wheel__slides" style={{ width: "100%" }}>
          {slideValues().map?.(({ style, value }, idx) =>{

            return(
            <div className="wheel__slide" style={{...style, display:"flex", justifyContent:"center"}} key={idx}>
              <span>{value}</span>
            </div>
          )
        }
          )}
        </div>
     
        {props?.label && (
          <div
            className="wheel__label"
            style={{
              transform: `translateZ(${radius}px)`,
              WebkitTransform: `translateZ(${radius}px)`,
            }}
          >
            {props?.label}
          </div>
        )}
      </div>
      <div
        className="wheel__shadow-bottom"
        style={{
          transform: `translateZ(${radius}px)`,
          WebkitTransform: `translateZ(${radius}px)`,
        }}
      />
    </div>
  )
}

//===============================================================

/* interface IProps {
  perspective?: string;
  loop?: boolean;
  width: number;
  length: number;
  initIdx?: number;
  label?: string;
  setValue?: (_: any, idx: any) => string;
} */

export const WheelPicker = (props) => {

    const perspective = props?.perspective || "center"
    const wheelSize = 20
    const slides = props?.length
    const slideDegree = 360 / wheelSize
    const slidesPerView = props?.loop ? 9 : 1
    const [sliderState, setSliderState] = useState(undefined)
    const size = useRef(0)

    function slideValues() {
        
        if (!sliderState) return []
  
        const offset = props?.loop ? 1 / 2 - 1 / slidesPerView / 2 : 0  
        const values = []
  
        //console.log("jdsncjdkscnjd",firstValue, lastValue, sliderState)
        for (let i = 0; i < slides; i++) {
          const distance = sliderState
            ? (sliderState?.slides[i]?.distance - offset) * slidesPerView
            : 0
          const rotate =
            Math.abs(distance) > wheelSize / 2
              ? 180
              : distance * (360 / wheelSize) * -1
          const style = {
            transform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
            WebkitTransform: `rotateX(${rotate}deg) translateZ(${radius}px)`,
          }
          const value = () => {
              if(props?.setValue) return props?.setValue(i, sliderState.abs + Math.round(distance))
              if(props?.startValue) return i + props?.startValue
             return i
          
          }
          values.push({ style, value: value() })
        }
        return values
      }

    const options = useRef({
      slides: {
        number: slides,
        origin: props?.loop ? "center" : "auto",
        perView: slidesPerView,
      },
  
      vertical: true,
  
      initial: props?.initIdx || 0,
      loop: props?.loop,
      dragSpeed: (val) => {
        const height = size.current
        return (
          val *
          (height /
            ((height / 2) * Math.tan(slideDegree * (Math.PI / 180))) /
            slidesPerView)
        )
      },
      created: (s) => {
        size.current = s.size
        //console.log("CREATED:", s)
      },
      updated: (s) => {
        size.current = s.size
        console.log("UPDATED:", s)
      },
      optionsChanged: (s) => {
        //console.log("SLIDE CHANGED:", s)
        //props?.wheelValue && props?.wheelValue(props?.startValue ? s.track.details?.rel + props?.startValue : s.track.details?.rel) 
      },
      detailsChanged: (s) => {
        setSliderState(s.track.details) 
        props?.wheelValue && props?.wheelValue(props?.startValue ? s.track.details?.rel + props?.startValue : s.track.details?.rel) 
        //console.log("CHANGED:", s.track.details)
      },
      rubberband: !props?.loop,
      mode: "snap",
    })
  
    const [sliderRef, slider] = useKeenSlider(options.current)
  
    const [radius, setRadius] = React.useState(0)
  
    useEffect(() => {
      if (slider.current) setRadius(slider.current.size / 2)
        
        //console.log("bjehbdjsb", slider)
    }, [slider])


  
    return (
      <div
        className={"wheel keen-slider wheel--perspective-" + perspective}
        ref={sliderRef}
      >
        <div
          className="wheel__shadow-top"
          style={{
            transform: `translateZ(${radius}px)`,
            WebkitTransform: `translateZ(${radius}px)`,
          }}
        />
        <div className="wheel__inner">
          <div className="wheel__slides" style={{ width: props?.width + "px" }}>
            {slideValues().map?.(({ style, value }, idx) => (
              <div className="wheel__slide" style={style} key={idx}>
                <span>{value}</span>
              </div>
            ))}
          </div>
       
          {props?.label && (
            <div
              className="wheel__label"
              style={{
                transform: `translateZ(${radius}px)`,
                WebkitTransform: `translateZ(${radius}px)`,
              }}
            >
              {props?.label}
            </div>
          )}
        </div>
        <div
          className="wheel__shadow-bottom"
          style={{
            transform: `translateZ(${radius}px)`,
            WebkitTransform: `translateZ(${radius}px)`,
          }}
        />
      </div>
    )
  }
  